import { DecisionAttachments } from "./DecisionAttachments";
import { DecisionDirections } from "./DecisionDirections";
import { DecisionMeetings } from "./DecisionMeetings";
import { DecisionOverview } from "./DecisionOverview";
import { DecisionAccess } from "./DecisionAccess";
import { DecisionReview } from "./DecisionReview";
import DecisionQuestionsList from "./DecisionQuestionsList";
import { STab, STabList, STabPanel, STabs } from "../../styles/Tabs";
import { StyledDecisionBody } from "../../styles/StyledDecision";
import { useSearchParams } from "react-router-dom";
import PropTypes from "prop-types";
import { DecisionChunks } from "./DecisionChunks";

export default function DecisonBody({ id, newDecision, edit, prefillData }) {
	const [searchParams] = useSearchParams();

	// For new decisions, always enable ALL tabs - users should be able to create decisions manually
	const enableAllTabsForNew = newDecision; // Always true for new decisions
	const shouldDisableTab = false; // Never disable tabs for new decisions

	return (
		<StyledDecisionBody sm={12}>
			{/* "Check the direction" links open the decision on the Direction tab */}
			<STabs
				selectedTabClassName="is-selected"
				selectedTabPanelClassName="is-selected"
				defaultIndex={searchParams.get("directionsTab") === "true" ? 2 : 0}
			>
				<STabList>
					<STab>Overview</STab>
					<STab>Addressee part</STab>
					<STab>Directions</STab>
					<STab>Attachments</STab>
					<STab>Access</STab>
					<STab>Review</STab>
					<STab>Meetings</STab>
					<STab>Questions</STab>
				</STabList>
				<>
						<STabPanel>
							<DecisionOverview edit={true} id={id} newDecision={newDecision} prefillData={prefillData} />
						</STabPanel>
						<STabPanel>
							<DecisionChunks id={id} newDecision={newDecision} />
						</STabPanel>
						<STabPanel>
							<DecisionDirections id={id} newDecision={newDecision} />
						</STabPanel>
						<STabPanel>
							<DecisionAttachments id={id} newDecision={newDecision} />
						</STabPanel>
						{/* <STabPanel>
					<DecisionMakers isMaker />
				</STabPanel> */}
						<STabPanel>
							<DecisionAccess newDecision={newDecision} />
						</STabPanel>
						<STabPanel>
							<DecisionReview id={id} newDecision={newDecision} />
						</STabPanel>
						<STabPanel>
							<DecisionMeetings id={id} newDecision={newDecision} />
						</STabPanel>
						<STabPanel>
							<DecisionQuestionsList id={id} newDecision={newDecision} />
						</STabPanel>
				</>
			</STabs>
		</StyledDecisionBody>
	);
}

DecisonBody.propTypes = {
	newDecision: PropTypes.bool,
	id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	edit: PropTypes.bool,
	prefillData: PropTypes.object,
};
